import React from 'react';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null, errorInfo: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Uncaught error:", error, errorInfo);
    this.setState({ errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center bg-gray-50 p-6">
          <div className="bg-white p-8 rounded-xl shadow-lg max-w-lg w-full border-l-4 border-red-500">
            <h1 className="text-2xl font-bold text-gray-900 mb-4">Noe gikk galt</h1>
            <p className="text-gray-600 mb-4">
              Applikasjonen støtte på en uventet feil. Prøv å laste siden på nytt.
            </p>
            <div className="bg-gray-100 p-4 rounded text-xs font-mono overflow-auto max-h-40 mb-6">
              {this.state.error && this.state.error.toString()}
            </div>
            <button 
              onClick={() => window.location.href = '/'} 
              className="bg-blue-600 text-white px-6 py-2 rounded-lg hover:bg-blue-700 transition-colors w-full"
            >
              Last siden på nytt (Gå til start)
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;